import AxiosClient from "../../../services/axios.services";

class FormTypeServices {
  getFormType = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_formularios/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getFormTypeById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_formularios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveFormType = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_formularios/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editFormType = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_formularios/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFormType = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_formularios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new FormTypeServices();
